export enum StreamStatus {
  Loading = "loading",
  Ongoing = "ongoing",
  Finished = "finished",
  Error = "error",
}

export interface StreamingState {
  streamStatus: Record<string, StreamStatus>;
  streamContent: Record<string, string>;
  isLoading: Record<string, boolean>;
}
